// extracted by mini-css-extract-plugin
module.exports = {"rightSidePannel":"layout_rightSidePannel__zL5u3","leftZoomWidth":"layout_leftZoomWidth__HhcA4","centerBox":"layout_centerBox__LIGKs"};